<template>
  <ValidationObserver ref="form" v-slot="{ handleSubmit }">
    <vue-element-loading :active="loading" text="Obteniendo información ..." spinner="bar-fade-scale" />
    <form class="mt-4" novalidate @submit.prevent="handleSubmit(onSubmit)">
    <b-row>
      <b-col>
        <ValidationProvider vid="name" name="Fist Name" rules="required" v-slot="{ errors }">
          <div class="form-group">
            <label for="name">Nombre</label>
            <input type="text" v-model="user.firstName" :class="'form-control mb-0' +(errors.length > 0 ? ' is-invalid' : '')"
                   id="name" aria-describedby="firstName" placeholder="Nombre">
            <div class="invalid-feedback">
              <span>{{ errors[0] }}</span>
            </div>
          </div>
        </ValidationProvider>
      </b-col>
      <b-col>
        <ValidationProvider vid="name" name="Last Name" rules="required" v-slot="{ errors }">
          <div class="form-group">
            <label for="name">Apellido</label>
            <input type="text" v-model="user.lastName" :class="'form-control mb-0' +(errors.length > 0 ? ' is-invalid' : '')"
                   id="name" aria-describedby="lastName" placeholder="Apellido">
            <div class="invalid-feedback">
              <span>{{ errors[0] }}</span>
            </div>
          </div>
        </ValidationProvider>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <ValidationProvider vid="name" name="Email" rules="required|email" v-slot="{ errors }">
          <div class="form-group">
            <label for="email">Email address</label>
            <input type="email" v-model="user.email" :class="'form-control mb-0' +(errors.length > 0 ? ' is-invalid' : '')"
                   id="email" aria-describedby="emailHelp" placeholder="Correo" autocomplete="off">
            <div class="invalid-feedback">
              <span>{{ errors[0] }}</span>
            </div>
          </div>
        </ValidationProvider>
      </b-col>
      <b-col>
        <ValidationProvider vid="password" name="Password" rules="required" v-slot="{ errors }">
          <div class="form-group">
            <label for="password">Password</label>
            <input type="password" v-model="user.password" :class="'form-control mb-0' +(errors.length > 0 ? ' is-invalid' : '')"
                   id="password" placeholder="Password" autocomplete="off">
            <div class="invalid-feedback">
              <span>{{ errors[0] }}</span>
            </div>
          </div>
        </ValidationProvider>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <ValidationProvider vid="name" name="NIT" rules="required" v-slot="{ errors }">
          <div class="form-group">
            <label for="name">NIT</label>
            <input type="text" v-model="company.nit" :class="'form-control mb-0' +(errors.length > 0 ? ' is-invalid' : '')"
                   id="name" aria-describedby="nit" placeholder="NIT">
            <div class="invalid-feedback">
              <span>{{ errors[0] }}</span>
            </div>
          </div>
        </ValidationProvider>
      </b-col>
      <b-col>
        <ValidationProvider vid="name" name="Name" rules="required" v-slot="{ errors }">
          <div class="form-group">
            <label for="name">Nombre Empresa</label>
            <input type="text" v-model="company.name" :class="'form-control mb-0' +(errors.length > 0 ? ' is-invalid' : '')"
                   id="name" aria-describedby="name" placeholder="Nombre empresa">
            <div class="invalid-feedback">
              <span>{{ errors[0] }}</span>
            </div>
          </div>
        </ValidationProvider>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <ValidationProvider vid="name" name="phone" rules="required" v-slot="{ errors }">
          <div class="form-group">
            <label for="name">Teléfono</label>
            <input type="text" v-model="company.phone" :class="'form-control mb-0' +(errors.length > 0 ? ' is-invalid' : '')"
                   id="name" aria-describedby="phone" placeholder="Teléfono">
            <div class="invalid-feedback">
              <span>{{ errors[0] }}</span>
            </div>
          </div>
        </ValidationProvider>
      </b-col>
      <b-col>
        <ValidationProvider vid="name" name="web" rules="required" v-slot="{ errors }">
          <div class="form-group">
            <label for="name">Web</label>
            <input type="text" v-model="company.web" :class="'form-control mb-0' +(errors.length > 0 ? ' is-invalid' : '')"
                   id="name" aria-describedby="name" placeholder="Página web empresa">
            <div class="invalid-feedback">
              <span>{{ errors[0] }}</span>
            </div>
          </div>
        </ValidationProvider>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <ValidationProvider vid="name" name="type" rules="required" v-slot="{ errors }">
          <div class="form-group">
            <label for="name">Tipo de empresa</label>
            <input type="text" v-model="company.type" :class="'form-control mb-0' +(errors.length > 0 ? ' is-invalid' : '')"
                   id="name" aria-describedby="type" placeholder="Tipo de empresa">
            <div class="invalid-feedback">
              <span>{{ errors[0] }}</span>
            </div>
          </div>
        </ValidationProvider>
      </b-col>
    </b-row>


      <div class="d-inline-block w-100">
        <button type="submit" class="btn btn-primary float-right">Registrar</button>
      </div>
      <div class="sign-info">
          <span class="dark-color d-inline-block line-height-2">
            Ya tienes una cuenta ?
            <router-link to="/auth/login" class="iq-waves-effect pr-4">
                Inicia sesión.
              </router-link>
          </span>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import axios from 'axios'
import firebase from 'firebase'
import { mapGetters } from 'vuex'
import SocialLoginForm from './SocialLoginForm'

export default {
  name: 'SignUp1Form',
  components: { SocialLoginForm },
  props: ['formType'],
  computed: {
    ...mapGetters({
      users: 'Setting/usersState'
    })
  },
  data: () => ({
    loading: false,
    user: {
      email: '',
      password: '',
      firstName: '',
      lastName: '',
      role: 'TmSXOFet8QM6iifVPCwz' // rol admin by default !!REFACTOR!!
    },
    company: {
      nit: '',
      name: '',
      owner: '',
      email: '',
      phone: '',
      web: '',
      type: '',
      plan_id: '',
      active: false
    }
  }),
  methods: {
    onSubmit () {
        this.loading = true;
        this.firebaseRegister()
    },
    async firebaseRegister () {
      firebase.auth().createUserWithEmailAndPassword(this.user.email, this.user.password).then(async (u) => {
        // console.log('Firebase Response', u);

        const userId = await this.createUser();
        console.log('User ID', userId);
        localStorage.setItem('ownerId', JSON.stringify({id: userId.data.data}))
        this.company.owner = userId.data.data;
        this.company.email = this.user.email;
        const company = await this.createCompany();

        this.loading = false;
        // this.$router.replace('/auth/login')
        this.$router.push('/auth/plan');

        // eslint-disable-next-line handle-callback-err
      }).catch((err) => {
        this.loading = false;
      })
    },
    async createUser() {
      return axios.post('https://us-central1-atpro-app.cloudfunctions.net/api/users/create', this.user)
    },
    async createCompany() {
      return axios.post('https://us-central1-atpro-app.cloudfunctions.net/api/companies/create', this.company)
    }
  }
}
</script>
